module.exports = __webpack_public_path__ + "static/media/Popcorn.c1477e2d.webp";